import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
    Aboutpage,
    Homepage,
    Games,
    GameDetail,
    Genres,
    GenreDetail,
    NotFound
} from '../pages';

const Routes = () => {
    return (
        <Switch>
            <Route exact path="/" component={Homepage} />
            <Route exact path="/games" component={Games} />
            <Route path="/games/:slug" component={GameDetail} />
            <Route exact path="/genres" component={Genres} />
            <Route path="/genres/:slug" component={GenreDetail} />
            <Route path="/about" component={Aboutpage} />
            <Route path="*" component={NotFound} />
        </Switch>
    );
};

export default Routes;
